export default "__VITE_ASSET__BDbPXDMF__"